import axiosInstance from './axiosConfig';

const getAuthToken = () => {
  return localStorage.getItem('accessToken');
};

const getAuthHeader = () => {
  const token = getAuthToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

export const RestaurantsService = {
  getAllRestaurants: async (query) => {
    try {
      const response = await axiosInstance.get(`/restaurants?queryType=${query}`);
      let data = response.data;

      // Sort if it's an array or if it has a restaurants array
      if (Array.isArray(data)) {
        data.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
      } else if (data && Array.isArray(data.restaurants)) {
        data.restaurants.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
      }

      return data;
    } catch (error) {
      console.error('Error fetching restaurants:', error);
      throw error;
    }
  },

  createRestaurant: async (restaurantData) => {
    try {
      const response = await axiosInstance.post('/restaurants/create', restaurantData);
      return response.data;
    } catch (error) {
      console.error('Error creating restaurant:', error);
      throw error;
    }
  },

  updateRestaurant: async (restaurantId, restaurantData) => {
    try {

      const response = await axiosInstance.put(`/restaurants/${restaurantId}`, restaurantData);
      return response.data;
    } catch (error) {
      console.error('Error updating restaurant:', error);
      throw error;
    }
  },

  searchData: async () => {
    try {
      const response = await axiosInstance.get('/users/searchData');
      return response.data;
    } catch (error) {
      console.error('Error fetching search data:', error);
      throw error;
    }
  },

  viewEmployee: async (restaurantId) => {
    try {
      const response = await axiosInstance.get(`/api/users/view-employees/${restaurantId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching employees:', error);
      throw error;
    }
  },

  transferOwnership: async (restaurantUuid, newOwnerId) => {
    try {
      const response = await axiosInstance.put(`/restaurants/${restaurantUuid}/transfer-ownership`, { newOwnerId });
      return response.data;
    } catch (error) {
      console.error('Error transferring ownership:', error);
      throw error;
    }
  }
}; 